module.exports = __webpack_public_path__ + "img/blanket_shipped.506b9e52.png";